'use client';

import { c as _c } from "react/compiler-runtime";
import { z } from '@repo/schema';
import { TEST_IDS } from '@repo/sdk/constants';
import { Button, Input } from '@repo/ui/components';
import { Minus, Plus } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { ChangeEvent } from 'react';
import { useFieldContext } from '../../lib/form-context.ts';
interface PalletsInputProps {
  autoFocus?: boolean;
  className?: string;
}

/**
 * wrap around ButtonGroup
 * @param autoFocus
 * @constructor
 */
export const PalletsInput = t0 => {
  const $ = _c(44);
  const {
    autoFocus
  } = t0;
  const field = useFieldContext();
  let T0;
  let handlePlus;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== autoFocus || $[1] !== field) {
    const parsedValue = z.coerce.number().catch(0).parse(field.state.value ?? 0);
    let t11;
    if ($[14] !== field || $[15] !== parsedValue) {
      t11 = () => {
        field.handleChange(parsedValue + 1);
      };
      $[14] = field;
      $[15] = parsedValue;
      $[16] = t11;
    } else {
      t11 = $[16];
    }
    handlePlus = t11;
    let t12;
    if ($[17] !== field || $[18] !== parsedValue) {
      t12 = () => {
        if (parsedValue <= 0) {
          return;
        }
        field.handleChange(parsedValue - 1);
      };
      $[17] = field;
      $[18] = parsedValue;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    const handleMinus = t12;
    let t13;
    if ($[20] !== field) {
      t13 = event => {
        const inputValue = event.target.value;
        const numberValue = Number(inputValue);
        field.handleChange(isNaN(numberValue) || numberValue < 0 ? 0 : numberValue);
      };
      $[20] = field;
      $[21] = t13;
    } else {
      t13 = $[21];
    }
    const handleInputChange = t13;
    let t14;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <Minus data-sentry-element="Minus" data-sentry-source-file="pallets-input.tsx" />;
      $[22] = t14;
    } else {
      t14 = $[22];
    }
    if ($[23] !== handleMinus) {
      t10 = <Button data-testid={TEST_IDS.cargo.packaging.minusButton} onClick={handleMinus} size="icon" type="button" variant="outline" data-sentry-element="Button" data-sentry-source-file="pallets-input.tsx">{t14}</Button>;
      $[23] = handleMinus;
      $[24] = t10;
    } else {
      t10 = $[24];
    }
    T0 = Input;
    t1 = autoFocus;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = cn("w-16 text-center");
      $[25] = t2;
    } else {
      t2 = $[25];
    }
    t3 = TEST_IDS.cargo.packaging.input;
    t4 = field.name;
    t5 = "numeric";
    t6 = 0;
    t7 = handleInputChange;
    t8 = "0";
    t9 = parsedValue.toString();
    $[0] = autoFocus;
    $[1] = field;
    $[2] = T0;
    $[3] = handlePlus;
    $[4] = t1;
    $[5] = t10;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    T0 = $[2];
    handlePlus = $[3];
    t1 = $[4];
    t10 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t11;
  if ($[26] !== T0 || $[27] !== t1 || $[28] !== t2 || $[29] !== t3 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t11 = <T0 autoFocus={t1} className={t2} data-testid={t3} id={t4} inputMode={t5} min={t6} onChange={t7} placeholder={t8} value={t9} data-sentry-element="Input" data-sentry-source-file="pallets-input.tsx" />;
    $[26] = T0;
    $[27] = t1;
    $[28] = t2;
    $[29] = t3;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Plus data-sentry-element="Plus" data-sentry-source-file="pallets-input.tsx" />;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== handlePlus) {
    t13 = <Button onClick={handlePlus} size="icon" type="button" variant="outline" data-sentry-element="Button" data-sentry-source-file="pallets-input.tsx">{t12}</Button>;
    $[38] = handlePlus;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== t10 || $[41] !== t11 || $[42] !== t13) {
    t14 = <>{t10}{t11}{t13}</>;
    $[40] = t10;
    $[41] = t11;
    $[42] = t13;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  return t14;
};